import * as React from "react"
import { ChangeEvent } from "react" 
import TextInput from "../TextInput";
import * as _ from "lodash";
import IPatientCondition from "../../models/IPatientCondition";
import TemplatedList from "../TemplatedList";
import ModelFactory from "../../models/ModelFactory";
import IConditionsUI from "../../models/IConditionsUI";
import {AppConstants, AppPlaceholders} from "../../utils/AppConstants";
import * as $ from "jquery";
import TypeAhead, { TypeAheadElement } from "../TypeAhead";

export interface ConditionItemWrapperEditorProps {
    item: IConditionsUI;
    onDataChange: (update: any) => any;
    showRelationshipDropdown: boolean;
    fetchStaticSymptomData: (name: string) => Promise<any>;
}

export interface ConditionItemWrapperEditorState {
    validate: boolean;
}

class ConditionItemWrapperEditor extends React.Component<ConditionItemWrapperEditorProps, ConditionItemWrapperEditorState> {
    private conditionWrapperDOM: any;

    constructor(props: ConditionItemWrapperEditorProps) {
        super(props)
        this.state = {
            validate: false
        }
    }

    componentDidMount() {
        let myInstance = this;
        $(this.conditionWrapperDOM).find("input").on("blur", function() {
            setTimeout(function() {
                if ( $(myInstance.conditionWrapperDOM).find("input:focus").length === 0 ) {
                    myInstance.setState({validate: true})
                }
            }, 100)
        })
    }

    onConditionRemove = (index: number) => {
        let currUpdatedConditions: IConditionsUI = {...this.props.item};
        currUpdatedConditions.items.splice(index, 1);
        
        this.props.onDataChange(currUpdatedConditions);
    };

    onConditionChange = (updatedItem: {item: IPatientCondition}, index: number) => {
        let currUpdatedConditions: IConditionsUI = {...this.props.item};
        currUpdatedConditions.items[index] = updatedItem.item;
        this.props.onDataChange(currUpdatedConditions);
    };

    onConditionNameChange = (event: ChangeEvent<HTMLInputElement>) => {
        let currUpdatedConditions = { ...this.props.item, name: event.target.value };
        this.props.onDataChange(currUpdatedConditions);
    }

    onConditionTypeAheadChange = (input: string) => {
        let updatedItem = { ...this.props.item, name: input };
        this.props.onDataChange(updatedItem);
       
        return this.props.fetchStaticSymptomData(input).then(symptoms => {
            let symptomTypeAhead: TypeAheadElement[] = [];
            _.map(symptoms, (symptom) => {
                let typeAheadElement: TypeAheadElement = {
                    value: symptom.id,
                    label: symptom.name
                }
                symptomTypeAhead.push(typeAheadElement);
            })
            return Promise.resolve({options: symptomTypeAhead, completed: true});
        }).catch(error => {
            throw error;
        });
    }

    onConditionTypeAheadSelect = (elem: TypeAheadElement) => {
        let updatedItem = { ...this.props.item, name: elem.label };
        this.props.onDataChange(updatedItem);
       
    }

    checkboxStatus = (): boolean => {
        let status = false;
        if (!_.isEmpty(this.props.item.items)) {
            if (this.props.item.items.length > 1) {
                status = true;
            } else {
                if (this.props.item.items.length === 1) {
                    let valid = ModelFactory.isValidCondition(this.props.item.items[0]);
                    if (valid) {
                        status = true
                    }
                }
            }
        }
        return status;
    }

    onConditionConfirm = () => {

    }

    getListItems = (condition: IConditionsUI) => {
        let listItems: {item: IPatientCondition}[] = []
        _.map(condition.items, (item, index) => {
            listItems.push({item})
        })
        return listItems;
    }

    render() {
        let conditionName = this.props.item.name !== null && this.props.item.name !== undefined ? this.props.item.name : "";
        let validCondition = this.props.item.items !== null && this.props.item.items.length === 1 ? ModelFactory.isValidCondition(this.props.item.items[0]) : true;
        let defaultItem = ModelFactory.createNewPatientCondition();
        let relationship = !_.isEmpty(this.props.item.items) ? this.props.item.items[0].relationship : null;
        if (this.props.item.items !== null && this.props.item.items.length !== 0 && relationship === AppConstants.PatientRelationshipConstant.SELF.internalValue) defaultItem.relationship = this.props.item.items[0].relationship;
        let conditionNameValidationStatus = this.state.validate && _.isEmpty(this.props.item.name) ? "error" : "";
        let conditionConfirmStatus = this.checkboxStatus();
        return (
            <div  className="condition-item-editor" style={{ width: "100%" }} ref={(conditionWrapperDOM) => this.conditionWrapperDOM = conditionWrapperDOM}>
                {/*<div className={"condition-editor-confirm"}>*/}
                    {/*<input type="checkbox" onChange={this.onConditionConfirm} checked={conditionConfirmStatus} />*/}
                {/*</div>*/}
                <div className={`condition-editor-name brandon-bold ${conditionNameValidationStatus}`}>
                    {/*<TextInput name={"conditionName"} value={conditionName} onChange={this.onConditionNameChange} placeholder={AppPlaceholders.CONDITIONS_EDITVIEW_NAME}/>*/}
                    <TypeAhead widgetName={"ConditionItemWrapper"} name={"conditionName"} value={conditionName || ""} placeholder={AppPlaceholders.CONDITIONS_EDITVIEW_NAME} onTypeAheadChange={this.onConditionTypeAheadChange} onTypeAheadSelect={this.onConditionTypeAheadSelect}/>
                </div>
                <TemplatedList templateName={"condition"} commonProps={{showRelationshipDropdown: this.props.showRelationshipDropdown, disableFields: _.isEmpty(conditionName)}}
                               defaultItem={{item: defaultItem}}
                               listItems={validCondition ? this.getListItems(this.props.item) : null}
                               onItemRemove={this.onConditionRemove}
                               onItemChange={this.onConditionChange}
                />
            </div>
        )
    }
}

export default ConditionItemWrapperEditor;
